<template>
  <div>
    <multiselect
      v-model="selected"
      :options="options"
      placeholder="Type to search"
      track-by="id"
      label="territory_name"
      :max-height="125"
      :allow-empty="allowEmpty"
      :multiple="isMultiple"
      :disabled="isDisabled"
    >
      <span slot="noResult">Oops! No data found</span>
      <template slot="singleLabel" slot-scope="props">
        <span class="option__desc">
          <span class="option__title"
            >{{ props.option.territory_name }} -
            {{ props.option.warehouse_code }}</span
          >
        </span>
      </template>

      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title"
            >{{ props.option.territory_name }} -
            {{ props.option.warehouse_code }}</span
          >
        </div>
      </template>
    </multiselect>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/repositoryFactory";
const masterRepo = RepositoryFactory.get("master");

export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      options: [],
      selected: null,
      params: {
        territory_id: null,
        id: null,
      },
    };
  },
  methods: {
    setDisabled(value) {
      this.isDisabled = value;
    },
    setIsDefaultOnly() {
      this.options.forEach((element) => {
        if (element.is_default == 1) {
          this.selected = element;
        }
      });
    },
    async setParams(params) {
      this.params = params;
    },
    async toggleDisabled() {
      this.isDisabled = !this.isDisabled;
    },
    async getWarehouseTerritory() {
      this.$vs.loading();
      try {
        const resp = await masterRepo.getWarehouseTerritory(this.params);
        if (resp.code == 200) {
          this.options = [];
          if (resp.data.records.length == 1) {
            this.selected = resp.data.records[0];
          } else {
            this.options = resp.data.records;
            this.isDisabled = false;
          }
        } else {
          this.$vs.notify({
            title: "Error",
            text: "Error while fetching territory warehouse",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching territory warehouse",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        console.log(error);
      }
      this.$vs.loading.close();
    },
    setNullData(){
      this.options  = [],
      this.selected = null,
      this.params   = {
        territory_id: null,
        id: null,
      };
    }
  },
  watch: {
    selected(v) {
      this.selected = v;
      this.$emit("data", v);
    },
  },
};
</script>
